import React, { Component } from  'react';
import { debounce } from 'vega';
import { drawVis } from "../util";
import { objEqual } from "../../js/util"
import "../css/SequenceContainer.css"
import { Badge } from 'react-bootstrap';



class SequenceContainer extends Component {
  constructor(props){
    super(props);
    this.state = {
      visDrawers: {}
    }

  }

  render() {



    const transitions = this.props.transitions;
    const sequence = this.props.sequence;
    const id = this.props.sequenceId;
    return <div className={`sequence-container border p-3 `} >
      {
        sequence.map((chart, j) => {
          let transition = transitions[j]
          return <div className=" text-center " key={`recomSeuqnece-${id}-${j}`}>
              <div
                className={["seqBox", "seqChart", "border"].join(" ")}

              >

                <Badge variant="secondary" className="chart-order-num ">{j+1}</Badge>
                <div id={`recomSequenceChart-${id}-${j}`}  className={"seqChart-container"}>
                  Loading...
                </div>

              </div>
              <div>
                {this.renderTransitionInfo(transition, j)}
              </div>

            </div>
        })
      }
    </div>
  }
  async componentDidMount() {

    this.updateSquence(this.props.sequenceId, this.props.sequence);
  }
  async componentDidUpdate(prevProps){
    this.updateSquence(this.props.sequenceId, this.props.sequence, prevProps.sequence);
  }
  async updateSquence (sequenceId, sequence, oldSequence) {

    const visDrawers = {...this.state.visDrawers};
    let isUpdated = false;
    for (let i = 0; i < sequence.length; i++) {
      const currChart = sequence[i];

      if (oldSequence) {
        const prevChart = oldSequence[i];
        if (objEqual(prevChart, currChart)) {
          isUpdated = false;
          continue;
        }
      }

      if (visDrawers[i]) {
        visDrawers[i](currChart)
      } else {
        let debounceDrawVis = this.genDebounceDrawVis(`#recomSequenceChart-${sequenceId}-${i}`)
        debounceDrawVis(currChart);
        visDrawers[i] = debounceDrawVis
        isUpdated = true;
      }

    }
    if (isUpdated) {
      this.setState(visDrawers)
    }
  }
  renderTransitionInfo(transition, transitionId) {
    if (!transition) {
      return "";
    }
    return <div key={`transitionBadgeGroup-${transitionId}`} className={"transition-badge-group"}>
      <span className="transition-arrow "/>
      -
      <div className="transition-badge-container">
        {
          transition.map((eo, j) => {
            return <Badge
                  variant="info"
                  key={`transitionBadge-${j}`}
                  className={"transition-badge"}
                >
                  {eo.name}
                </Badge>
          })
        }
      </div>
    </div>
  }

  genDebounceDrawVis(target) {
    return (spec) => {
      debounce(700, async () => { await drawVis( target, spec ) })();
    }
  }
}

export default SequenceContainer;
